// ##### Komarov 2025-07-12
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
// ##### 23-03-29 Komarov
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
// ##### 24-01-05 Komarov: ConfigProvider - средство конфигурирования локали для календариков
// ##### 23-12-11 Komarov
import { Alert, ConfigProvider, DatePicker, Space } from 'antd';
import Autocomplete from 'react-autocomplete';
// ##### 24-01-05 Komarov: Оъбект с форматами дат соответственно локалям (обязательно названия языков в нём должны совпадать с названиями локалей в antd)
import dateFormats from '../../../../../helpers/dateFormats';
// ##### 25-05-21 Komarov
import HotelsPaxChoice from '../HotelsPaxChoice/HotelsPaxChoice';
import PromoCode from '../PromoCode';

// ##### 25-01-22 Komarov
import {
  changeLang,
  getAutocompleteData,
  getPages,
  setItemInfo,
  setPaxListOpen,
} from '../../../../../Redux/actions';
import ClearInput from '../../../../Library/PageDevices/ClearInput';
import getIcon from '../helpers/getIcon';
// ##### 23-11-02 Komarov
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 24-02-02 Komarov
import OutsideClickHandler from 'react-outside-click-handler';
// ##### 24-04-05 Komarov
import uniqueId from 'lodash.uniqueid';
// ##### 24-04-17 Komarov
import { makeParamsString } from '../../../Helpers/helper';
// ##### 25-05-21 Komarov
import HotelsCitiesAvailabilityHint from './HotelsCitiesAvailabilityHint';
// ##### 24-12-27 Komarov
import { encryptString } from '../../../../../helpers/crypto';
// ##### 25-03-11 Komarov
import { dateLocales } from '../../../../../helpers/locales';
// ##### 25-03-12 Komarov
import { makeItemsArray } from '../../../../../helpers/makeItemsArray';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../../../server/helpers/uniLog';
// ##### Komarov 2025-07-21
import useValidateQuery from '../../../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-21
const HotelsAutocomplete = ({ formClass, datepickerClass, switcherRef }) => {
  // ##### Komarov 2025-07-21
  const searchProps = useValidateQuery();
  // ##### Komarov 2025-07-12
  const language = useSelector(state => state.language);
  useEffect(() => {
    moment.locale(language);
  }, [language]);
  // ##### 24-05-21 Komarov
  const hotelsCitiesAvailabilityHintRef = useRef();

  // ##### 23-10-05 Komarov: Устанавливаем положение календарика с выбором даты в зависимости от положения прокрутки окна
  const [datePickerPlacement, setDatePickerPlacement] = useState('topLeft');

  // ##### 24-06-13 Komarov: Управление положением календарика на экране
  // ##### Komarov 2025-07-12
  useEffect(() => {
    if (window.scrollY > 250) {
      setDatePickerPlacement('bottomLeft');
    } else setDatePickerPlacement('topLeft');
    // ##### 24-07-25 Komarov
  }, []);

  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);

  // console.log('REGEX',lettersOnlyString(searchProps.title))

  const [stayDates, setStayDates] = useState(
    searchProps ? [searchProps.start, searchProps.end] : []
  );
  const [pickedStartDate, setPickedStartDate] = useState(!!searchProps);
  const [pickedEndDate, setPickedEndDate] = useState(!!searchProps);
  const [list, setList] = useState([]);
  // ##### 24-04-29 Komarov
  const [hotelsvalue, setHotelsValue] = useState(
    searchProps ? decodeURIComponent(searchProps?.title) : ''
  );
  // ##### 24-04-05 Komarov
  const selectedItemInfoInitialState = undefined;
  const [selectedItemInfo, setSelectedItemInfo] = useState(
    selectedItemInfoInitialState
  );
  const [open, setOpen] = useState(false);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    open &&
      hotelsCitiesAvailabilityHintRef.current &&
      hotelsCitiesAvailabilityHintRef.current.classList.add('show');
    !open &&
      hotelsCitiesAvailabilityHintRef.current &&
      hotelsCitiesAvailabilityHintRef.current.classList.remove('show');
  }, [open]);
  const [crossVisible, setCrossVisible] = useState(false);
  const [pickedHotelValue, setPickedHotelValue] = useState(!!searchProps);
  // ##### Komarov 2025-07-19
  const [autocompleteFocused, setAutocompleteFocused] = useState(false);
  const { paxListOpen } = useSelector(state => state.paxchoice);

  const history = useHistory();

  // ##### 24-02-22 Komarov
  const pickedcurrencyFromState = useSelector(
    state => state.currency.pickedcurrency
  );
  // ##### 24-07-25 Komarov
  const pickedcurrency =
    pickedcurrencyFromState ||
    JSON.parse(localStorage.getItem('currency')).pickedcurrency;

  const dispatch = useDispatch();
  // ##### Komarov 2025-08-05
  const autocomplete_data = useSelector(
    state => state.hotels.autocomplete_data[locale]
  );
  const autocomplete_data_loaded = useSelector(
    state => state.hotels.autocomplete_data_loaded[locale]
  );
  // ##### 25-03-12 Komarov
  const autocomplete_data_list =
    autocomplete_data_loaded &&
    makeItemsArray(autocomplete_data.data.data.list);
  // ##### 25-03-12 Komarov
  const totalPaxReduxAdults = useSelector(state => state.paxchoice.pax.adults);
  const totalPaxReduxChildren = useSelector(
    state => state.paxchoice.pax.children
  );
  const totalPaxReduxRooms = useSelector(state => state.paxchoice.pax.rooms);
  const promoCode = useSelector(state => state.promocode.promocode);
  // console.log('TOTALPAXREDUX',totalPaxRedux)

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(changeLang());
    // ##### 23-04-12 Komarov
  }, [dispatch]);

  // ##### 24-04-23 Komarov
  const pagesFromLocalStorage = useSelector(
    state => state.pagesRedux[state.language]
  );

  // ##### Komarov 2025-07-12
  useEffect(
    () => {
      if (pagesFromLocalStorage) {
        return;
      }
      // ##### 25-04-30 Komarov
      uniLog(
        'axios:src/Components/Pages/FirstPageofSearchModule/HotelsAutocompleteBlock/HotelsAutocomplete.js:getPages(lang)'
      );
      // ##### 23-12-27 Komarov
      dispatch(getPages(locale));
    },
    // ##### 24-01-05 Komarov
    [locale, dispatch, pagesFromLocalStorage]
  );

  // ##### Komarov 2025-10-14
  const hotelcontentData = useSelector(
    state => state.hotelcontent?.hotelcontent?.data
  );
  const cityName = hotelcontentData?.ci_title;
  useEffect(() => {
    if (cityName) {
      setHotelsValue(cityName);
    }
  }, [locale, cityName]);

  // ##### 25-05-19 Komarov
  const StartDate = useSelector(
    state => state.pagesRedux[state.language]?.StartDate || ''
  );
  const EndDate = useSelector(
    state => state.pagesRedux[state.language]?.EndDate || ''
  );
  const PleaseInputCityorHotelName = useSelector(
    state => state.pagesRedux[state.language]?.PleaseInputCityorHotelName || ''
  );

  // console.log('TESTING', name.sort((a,b)=>a.city-b.city))

  // console.log('PLACEHOLDER',placeholder)

  // console.log('TOTALPAX', totalPaxRedux)

  const { RangePicker } = DatePicker;

  // ##### Komarov 2025-09-11
  const sale = useSelector(state => state.company.sale_id);
  const promocode = useSelector(state => state.promocode.promocode);
  const { user: currentUser } = useSelector(state => state.auth);
  const company_id = useSelector(state => state.auth.user.company_id);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 25-03-12 Komarov
    if (autocomplete_data_loaded) {
      return;
    }
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/FirstPageofSearchModule/HotelsAutocompleteBlock/HotelsAutocomplete.js:getAutocompleteData'
    );
    // ##### 25-03-12 Komarov
    dispatch(
      getAutocompleteData({
        // ##### Komarov 2025-05-26
        sale_id: sale || null,
        promocode,
        user_id: currentUser.user_id,
        refpartner: company_id,
        language: locale,
      })
    );
    // ##### 25-03-26 Komarov
  }, [autocomplete_data_loaded, locale]);

  // ##### 24-03-21 Komarov
  function onChange(_dates, dateStrings) {
    // ##### 24-05-27 Komarov
    if (dateStrings[0] && dateStrings[1]) {
      setStayDates(dateStrings);
      setPickedStartDate(true);
      setPickedEndDate(true);
      return;
    }
    setSearchClicked(false);
    setPickedStartDate(false);
    setPickedEndDate(false);
  }

  const optionChecker = e => {
    // console.log('[VALUE] : ', e.target.value)

    setHotelsValue(e.target.value);
    // ##### 23-04-12 Komarov
    if (hotelsvalue.length > 0) {
      setOpen(true);
    }
  };

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(setItemInfo(selectedItemInfo));
  }, [selectedItemInfo, dispatch]);

  ////FOR DATEPICKER (RANGEDATEPICKER) TO DISABLE CHOICE OF DATES THAT ARE BEFORE TODAY

  const disabledDate = current => {
    return current < moment().subtract(1, 'days');
  };
  // ##### 24-04-23 Komarov
  const chooseYourHotel = useSelector(
    state => state.pagesRedux[state.language]?.ChooseYourHotel || ''
  );
  const pickUpYourDatesOfStay = useSelector(
    state => state.pagesRedux[state.language]?.PickUpYourDatesOfStay || ''
  );
  // ##### 23-10-04 Komarov
  const Search = useSelector(
    state => state.pagesRedux[state.language]?.Search || ''
  );

  // ##### 23-12-11 Komarov
  const [searchClicked, setSearchClicked] = useState(false);
  const [formFilled, setFormFilled] = useState(false);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    setFormFilled(
      pickedHotelValue !== false &&
        hotelsvalue !== '' &&
        pickedStartDate !== false &&
        pickedEndDate !== false
    );
  }, [pickedHotelValue, hotelsvalue, pickedStartDate, pickedEndDate]);
  // ##### Komarov 2025-07-12
  const whitelabel = useSelector(state => state.whitelabel);
  const isWhiteLabelSet = whitelabel.set;
  const company_cipher = whitelabel.company_cipher;

  // ##### Komarov 2025-08-02
  const shouldCypherUrlParams = useSelector(
    state => state.siteCypherCodeData.isDataEncrypted
  );

  const addToList = () => {
    // ##### 23-12-11 Komarov
    setSearchClicked(true);

    if (!formFilled) {
      return;
    }
    // ##### 25-04-21 Komarov
    const id = localStorage.getItem('hotel_id'); // hotel's id

    // ##### 25-03-12 Komarov
    const hotelNewList = {
      // id: filteredHotels[0].id,
      // ##### 25-04-21 Komarov
      id, // hotel's id
      title: hotelsvalue,
      date: stayDates,
    };

    setList([...list, hotelNewList]);

    const params_string = makeParamsString({
      selected_currency:
        localStorage.getItem('current_currency') || pickedcurrency,
      title: hotelsvalue,
      start:
        (moment(stayDates[0], dateFormats[locale]).isValid() &&
          moment(stayDates[0], dateFormats[locale]).format(dateFormats.en)) ||
        moment(stayDates[0], dateFormats.en).format(dateFormats.en),
      end:
        (moment(stayDates[1], dateFormats[locale]).isValid() &&
          moment(stayDates[1], dateFormats[locale]).format(dateFormats.en)) ||
        moment(stayDates[1], dateFormats.en).format(dateFormats.en),
      // ##### 25-04-21 Komarov
      id: (!!parseInt(localStorage.getItem('isCitySelected')) && '0') || id, // hotel's id
      // city_id: filtered_hotelcity_id,
      city_id: localStorage.getItem('city_id'),
      adults: totalPaxReduxAdults,
      children: totalPaxReduxChildren,
      rooms: totalPaxReduxRooms,
    });

    // ##### 24-12-27 Komarov
    localStorage.setItem('selectedItemInfo', JSON.stringify(selectedItemInfo));

    const route_query = `?${shouldCypherUrlParams ? encryptString(params_string) : params_string}`;
    // ##### 24-02-29 Komarov: TODO: Убрать промокод из URL
    if (isWhiteLabelSet) {
      history.push(
        `/${locale}/ref${company_cipher}/search_results_hotels/${route_query}`,
        [...list, hotelNewList]
      );
    } else if (promoCode) {
      history.push(`/${locale}/search_results_hotels/${route_query}`, [
        ...list,
        hotelNewList,
      ]);
    } else {
      history.push(`/${locale}/search_results_hotels/${route_query}`, [
        ...list,
        hotelNewList,
      ]);
    }
  };

  // +++++
  const MakeVisible = value => {
    value === false || value === true
      ? dispatch(setPaxListOpen(value))
      : dispatch(setPaxListOpen(!paxListOpen));
  };

  const VisibleCross = () => {
    if (hotelsvalue !== '') {
      setCrossVisible(true);
    }
  };

  const NotVisibleCross = () => {
    setCrossVisible(false);
  };

  const clearInput = () => {
    // ##### 24-04-11 Komarov
    localStorage.removeItem('city_id');
    setHotelsValue('');
    // ##### 24-04-05 Komarov
    setSelectedItemInfo(selectedItemInfoInitialState);
    // ##### 24-05-27 Komarov
    setSearchClicked(false);
  };

  // ##### Komarov 2025-07-21
  const autocompleteRef = useRef();

  // ##### Komarov 2025-07-12
  useEffect(() => {
    if (autocompleteFocused) {
      autocompleteRef.current.focus();
    }
  }, [autocompleteFocused]);

  return (
    <div data-component="HotelsAutocomplete">
      <form
        className={formClass}
        onSubmit={e => {
          e.preventDefault();
          addToList();
        }}
      >
        {/* ##### 23-12-11 Komarov */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <OutsideClickHandler
            onOutsideClick={() => {
              setAutocompleteFocused(false);
              if (hotelsvalue === '') {
                setPickedHotelValue(false);
              }
            }}
          >
            <div
              style={{
                gridColumn: '1',
                display: 'flex',
                flexDirection: 'row-reverse',
                justifyContent: 'space-around',
              }}
              onMouseEnter={VisibleCross}
              onMouseLeave={NotVisibleCross}
              // ##### 24-02-02 Komarov
              onClick={() => setAutocompleteFocused(true)}
              onKeyDown={event => {
                if (event.key === 'Enter' || event.key === ' ') {
                  setAutocompleteFocused(true);
                }
              }}
              id="HotelsAutocomplete"
            >
              {(autocompleteFocused || pickedHotelValue) && (
                <ClearInput
                  makevisible={crossVisible}
                  clearInput={clearInput}
                />
              )}

              {((autocompleteFocused || pickedHotelValue) &&
                autocomplete_data_loaded && (
                  <Autocomplete
                    ref={autocompleteRef}
                    value={hotelsvalue}
                    inputProps={{
                      style: {
                        // width: `${width*0.8/4}px`,
                        height: '45px',
                        // ##### 23-03-29 Komarov
                        // fontFamily: 'Tahoma',
                        fontFamily: 'Arial',
                        fontSize: '16px',
                        border: 'none',
                        marginTop: '0.2vw',
                        textAlign: 'center',
                        position: 'relative',
                      },
                    }}
                    menuStyle={{
                      fontFamily: 'Arial Narrow',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      color: 'darkslategrey',
                      borderRadius: '3px',
                      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                      background: 'rgba(255, 255, 255)',
                      padding: '3px',
                      // ##### 24-06-28 Komarov
                      // overflow: "scroll",
                      overflowY: 'auto',
                      maxHeight: '30vh',
                      zIndex: '2000',
                      border: '2px solid grey',
                      position: 'absolute',
                      display: 'block',
                      // left:'160px',
                      top: '609',
                      // left:'20%',
                      // top:'50%'
                    }}
                    // ##### 25-03-12 Komarov
                    items={autocomplete_data_list}
                    getItemValue={item => item.name}
                    onChange={optionChecker}
                    onSelect={(value, item) => {
                      localStorage.setItem('city_id', item.city_id);
                      // ##### 25-03-12 Komarov
                      localStorage.setItem('hotel_id', item.id);
                      localStorage.setItem('isCitySelected', item.city);
                      // ##### 25-03-11 Komarov
                      setHotelsValue(value);
                      setOpen(false);
                      setPickedHotelValue(true);
                      setSelectedItemInfo(item);
                    }}
                    renderItem={(item, highlighted) => (
                      <div
                        // ##### 24-04-05 Komarov
                        key={uniqueId()}
                        style={{
                          backgroundColor: highlighted
                            ? 'lightblue'
                            : 'transparent',
                        }}
                      >
                        {getIcon(item)} {item.name}{' '}
                        {item.city === 0 ? ' city' : null}
                      </div>
                    )}
                    shouldItemRender={(item, value) =>
                      value !== ''
                        ? item.name.toLowerCase().includes(value.toLowerCase())
                        : null
                    }
                    open={open}
                    // ##### 24-03-21 Komarov
                    onMenuVisibilityChange={() => setOpen(false)}
                  />
                )) || (
                <div
                  style={{
                    height: '45px',
                    fontFamily: 'Tahoma',
                    fontSize: '14px',
                    color: 'rgb(75, 73, 73)',
                    border: 'none',
                    marginTop: '0.2vw',
                    textAlign: 'center',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {PleaseInputCityorHotelName}
                </div>
              )}
            </div>
          </OutsideClickHandler>
          {/* ##### 23-12-11 Komarov */}
          {searchClicked &&
            (pickedHotelValue === false || hotelsvalue === '') && (
              <Alert message={chooseYourHotel} type="error" />
            )}
        </div>

        {/* ##### 23-12-11 Komarov */}
        <div
          style={{
            gridColumn: '2',
            borderLeft: '0.5px solid grey',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
            // ##### 24-02-02 Komarov
            id="RangePicker"
          >
            {/* ##### 24-01-03 Komarov */}
            <Space direction="horizontal">
              {/* ##### 23-12-18 Komarov */}
              <ConfigProvider locale={dateLocales[locale]}>
                <RangePicker
                  size={'middle'}
                  disabledDate={disabledDate}
                  allowClear={true}
                  onChange={onChange}
                  defaultValue={
                    searchProps && [
                      moment(searchProps.start, dateFormats.en),
                      moment(searchProps.end, dateFormats.en),
                    ]
                  }
                  format={dateFormats[locale]}
                  bordered={false}
                  className={datepickerClass}
                  placeholder={[StartDate, EndDate]}
                  allowEmpty={searchProps && [false, false]}
                  placement={datePickerPlacement}
                />
              </ConfigProvider>
            </Space>
          </div>
          {/* ##### 23-12-11 Komarov */}
          {searchClicked &&
            pickedStartDate === false &&
            pickedEndDate === false && (
              <Alert message={pickUpYourDatesOfStay} type="error" />
            )}
        </div>

        {/* ##### 23-11-02 Komarov */}
        <Media
          at="Tablet-768-1024"
          style={{
            gridColumn: '3',
            borderLeft: '0.5px solid grey',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          <HotelsPaxChoice />
        </Media>
        <Media
          lessThan="Tablet-768-1024"
          style={{
            gridColumn: '3',
            borderLeft: '0.5px solid grey',
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          <HotelsPaxChoice />
        </Media>
        <Media
          greaterThan="Tablet-768-1024"
          style={{
            gridColumn: '3',
            borderLeft: '0.5px solid grey',
            display: 'flex',
            alignItems: 'center',
            // ##### 24-01-30 Komarov
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          <HotelsPaxChoice />
        </Media>

        <div
          style={{
            gridColumn: '4',
            borderLeft: '0.5px solid grey',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // ##### 23-05-08 Komarov
            position: 'relative',
          }}
        >
          {/* ##### 24-08-05 Komarov */}
          {/* TODO: Исправить код в соответствии с разницей понятий refpartner и promoCode */}
          <PromoCode /* refpartner={searchProps ? searchProps.refpartner : ""} */
          />
        </div>

        <button style={{ gridColumn: '5' }} type="submit">
          {
            // ##### 23-10-04 Komarov
            Search
          }
        </button>
      </form>
      {/* ##### 24-05-21 Komarov */}
      <HotelsCitiesAvailabilityHint
        hotelsCitiesAvailabilityHintRef={hotelsCitiesAvailabilityHintRef}
        switcherRef={switcherRef}
      />
    </div>
  );
};

export default HotelsAutocomplete;
